import React from 'react';
import { ArrowRight, Shield, Award, Users } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2070&auto=format&fit=crop"
          alt="Professional workplace"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/85 to-emerald-900/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="space-y-8">
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-tight">
            Expert Health, Safety &
            <span className="block text-emerald-400">Environmental Consultancy</span>
          </h1>
          <p className="text-xl sm:text-2xl text-gray-200 max-w-3xl mx-auto">
            Comprehensive risk management and compliance solutions tailored to your business needs
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
            <Button
              size="lg"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="bg-emerald-600 hover:bg-emerald-700 text-white text-lg px-8 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              Get Started
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-emerald-600 text-lg px-8 py-6 rounded-lg transition-all duration-300"
            >
              Our Services
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-16 max-w-4xl mx-auto">
            <div className="flex flex-col items-center space-y-2">
              <div className="p-4 bg-emerald-500/20 rounded-full backdrop-blur-sm">
                <Shield className="text-emerald-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-white">Certified</h3>
              <p className="text-gray-300">ISO Accredited</p>
            </div>
            <div className="flex flex-col items-center space-y-2">
              <div className="p-4 bg-emerald-500/20 rounded-full backdrop-blur-sm">
                <Award className="text-emerald-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-white">Professional</h3>
              <p className="text-gray-300">Expert Consultants</p>
            </div>
            <div className="flex flex-col items-center space-y-2">
              <div className="p-4 bg-emerald-500/20 rounded-full backdrop-blur-sm">
                <Users className="text-emerald-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-white">Trusted</h3>
              <p className="text-gray-300">Client Focused</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
